@import "../../../globals/main.scss";

@import "./pn-marketweb-siteheader-common.scss";

body[data-siteheader-menuopen="true"] {
  max-height: 100vh;
  overflow: hidden;
  @media screen and (min-width: $siteheader-media-smalldesktop) {
    max-height: initial;
    overflow: initial;
  }
}

pn-marketweb-siteheader {
  display: block;
  background: $white;
  header {
    position: relative;
    z-index: 1000;
    display: flex;
    flex-flow: column;
    box-shadow: $siteheader-shadow-elevation8;
    flex-direction: row;
    justify-content: space-between;
    @media screen and (min-width: $siteheader-media-tablet) {
      flex-direction: column;
      justify-content: initial;
    }
  }

  .siteheader-row {
    display: flex;
    flex-flow: row;
    align-items: center;

    width: 100%;
    padding: 0 1.6rem;

    min-height: 2em;
    &:not(:last-child) {
      border-bottom: 0.1rem solid $gray50;
    }
    @media screen and (min-width: $siteheader-media-tablet) {
      justify-content: space-between;
      min-height: 3.2em;
    }

    @media screen and (max-width: $siteheader-media-tablet) {
      &:last-child {
        justify-content: flex-end;
      }
    }
  }

  .siteheader-topright {
    display: flex;
    flex-direction: row;
  }

  .siteheader-logocontainer {
    display: flex;
    align-items: center;
    position: relative;
    min-height: 3em;
    background: $white;
    z-index: 1;

    @media screen and (min-width: $siteheader-media-tablet) {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .siteheader-logolink {
    height: 100%;
    max-height: 6.4rem;
    display: flex;
    align-items: center;
    &:hover,
    &:focus,
    &:active {
      box-shadow: none;
    }
  }

  .siteheader-row > pn-marketweb-siteheader-search {
    display: none;
    @media screen and (min-width: $siteheader-media-tablet) {
      display: block;
      max-width: 30rem;
      min-width: 23.3rem;
      width: 100%;
    }
  }

  .siteheader-row pn-button {
    button:hover {
      .pn-button-bg,
      .pn-button-bg::after {
        background-color: $blue50;
      }
    }
  }

  pn-spinner {
    display: none;
  }

  pn-button-dropdown:not(.hydrated) {
    .pn-button-dropdown-container {
      display: none;
    }
  }

  pn-button {
    button {
      font-weight: 400 !important;
      padding: 0.5rem !important;

      .pn-button-bg:after {
        border-radius: 0.8rem !important;
      }
    }
  }
}

.siteheader-topleft {
  pn-site-selector {
    padding: 1rem 0;
    display: none;
    @media screen and (min-width: $siteheader-media-tablet) {
      display: block;
    }
    @media screen and (min-width: $siteheader-media-smalldesktop) {
      margin-left: 1.3rem;
    }
    .pn-button-dropdown-label,
    &:is(a) {
      font-size: 0;
      pn-icon {
        font-size: initial;
        margin-left: 0;
      }
      @media screen and (min-width: $siteheader-media-smalldesktop) {
        font-size: initial;
        pn-icon {
          margin-left: 0.4em;
        }
      }
    }
  }
}
.siteheader-topright {
  @media screen and (min-width: $siteheader-media-smalldesktop) {
    margin-right: 1.6rem;
  }
  > pn-language-selector,
  > pn-marketweb-siteheader-login,
  > a {
    //pn-language-selector {
    padding: 1rem 0;
    display: none;
    align-self: center;
    @media screen and (min-width: $siteheader-media-tablet) {
      display: block;
      margin-left: 1rem;
    }
    @media screen and (min-width: $siteheader-media-smalldesktop) {
      margin-left: 1.6rem;
    }

    .pn-button-dropdown-label,
    &:is(a) {
      font-size: 0;
      pn-icon {
        font-size: initial;
        margin-left: 0;
      }
      @media screen and (min-width: $siteheader-media-smalldesktop) {
        font-size: initial;
        pn-icon {
          margin-left: 0.4em;
        }
      }
    }
  }
}

.siteheader-menu {
  max-width: 100%;
  overflow: visible;
  overflow-x: clip;
  @media screen and (min-width: $siteheader-media-smalldesktop) {
    margin-top: auto;
    overflow: visible;
  }
  pn-mainnav-link a[target] {
    &::after {
      content: none;
    }
  }

  pn-marketweb-siteheader-search {
    padding: 0.3rem 1.6rem;
    width: 100%;
  }
  [slot="top"] pn-search-field {
    width: 100%;
  }
}

.siteheader-menu-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  > * {
    margin: 1.6rem;
  }
}

.header-wrapper[data-header-theme="dotcom"] {
  & > pn-marketweb-siteheader {
    pn-button a {
      text-decoration: none;
      &:hover {
        text-decoration: none;
      }
    }

    & > header {
      background-color: $blue900;
      box-shadow: none;

      .siteheader-row:not(:last-child) {
        border-bottom: 0.1rem solid $blue900;
      }

      .siteheader-row pn-button button:hover {
        .pn-button-bg,
        .pn-button-bg::after {
          background-color: $blue700 !important;
        }
      }

      .siteheader-topleft {
        pn-site-selector .pn-button-dropdown-label {
          color: $white;
          pn-icon {
            svg > path {
              fill: $white;
            }
          }
        }

        button.pn-button-dropdown-label {
          &:hover {
            background-color: $blue700;
          }
          &:active {
            background-color: $blue400;
          }
          &:focus {
            background-color: $blue400;
          }
        }
      }

      .siteheader-logocontainer {
        background-color: $blue900;
        svg.siteheader-logo > path {
          fill: $blue400;
        }
      }

      .siteheader-topright {
        .siteheader-logindialog {
          svg > path {
            fill: $white;
          }
        }

        pn-language-selector {
          pn-icon {
            svg > path {
              fill: $white !important;
            }
          }
        }

        button {
          color: $white;

          &:hover {
            background-color: $blue700;
          }
          &:active {
            background-color: $blue700;
          }
          &:focus {
            background-color: $blue700;
          }
        }

        [slot="toprightend"] {
          @media screen and (max-width: $siteheader-media-tablet) {
            display: none;
          }
          align-self: center;
          margin-left: 1rem;
        }
      }

      .siteheader-menu {
        .mainnav-toggle {
          button {
            background-color: $blue700;
          }
        }
        .first-level_icon {
          svg > path {
            fill: $white;
          }
        }
      }

      .siteheader-search form pn-search-field {
        input {
          background-color: $white;
          color: $blue900;
          border: 0.1rem solid $white;
          padding: 0.65rem 1.5rem;

          &:hover {
            border-color: $white;
          }
          &::placeholder {
            color: $blue900;
          }
        }
      }

      //main-nav-level
      nav.mainnav {
        background-color: $blue900;

        @media screen and (min-width: $siteheader-media-tablet) {
          top: 6.4em;
        }

        pn-mainnav-level {
          [slot="top"].siteheader-menu-top {
            pn-marketweb-siteheader-search {
              padding-bottom: 0.5rem;
              background-color: $blue900;

              .button-container {
                border-top: 1px solid $white;
                border-bottom: 1px solid $white;
                border-right: 1px solid $white;
                border-top-right-radius: 50%;
                border-bottom-right-radius: 50%;

                button.clear {
                  border: 2px solid $white;
                  border-radius: 50%;
                  padding: 0.5rem;
                }
              }
            }
          }

          .mainnav-level-header {
            .secondlevel-backbtn {
              pn-icon {
                svg > path {
                  fill: $white;
                }
              }
            }
          }

          pn-mainnav-level[data-level="2"] {
            .mainnav-level-header {
              pn-mainnav-link > a {
                &:hover {
                  background-color: $blue400;
                }
              }
            }
          }

          pn-mainnav-list > pn-mainnav-link {
            button,
            a {
              background-color: $blue900;
              border-bottom: 0.1rem solid rgba(0, 93, 146, 0.5);
              &:hover {
                text-decoration: none;
              }
              @media screen and (min-width: 1024px) {
                border-bottom: none;
              }
            }
          }
        }

        pn-mainnav-level[data-level="1"] {
          pn-mainnav-list > pn-mainnav-link {
            @media screen and (max-width: 1023px) {
              &:first-child {
                border-top: 0.1rem solid rgba(0, 93, 146, 0.5);
              }
            }

            & a,
            & button {
              color: $white;
              &:focus {
                outline: none;
              }
            }
          }
        }
        pn-mainnav-level:not([data-level="1"]) {
          background-color: $blue900;
          pn-mainnav-list {
            color: $white;
            pn-mainnav-link > a {
              &:hover {
                background-color: $blue400;
                text-decoration: none;
              }
            }
          }
        }

        pn-marketweb-siteheader-login-linklist {
          ul li a:not(.pn-button) {
            color: $blue700;
          }
          ul li a:hover {
            color: $white;
          }
        }
      }

      [data-level="1"] pn-mainnav-link pn-icon.first-level_arrow {
        svg > path {
          fill: $white;
        }
      }

      .siteheader-menu-footer {
        button {
          color: $white;
          &:hover {
            background-color: $blue700;
          }
          &:active {
            background-color: $blue700;
          }
          &:focus {
            background-color: $blue700;
          }

          svg > path {
            fill: $white;
          }
        }

        [slot="menu-footer-cta"] {
          @media screen and (min-width: $siteheader-media-tablet) {
            display: none;
          }
        }
      }
    }
  }
}

.siteheader-menu-top-search {
  display: none;
}

.header-wrapper[data-header-theme="tpl"],
.header-wrapper[data-header-theme="dotcom"] {
  @media screen and (min-width: $siteheader-media-tablet) {
    pn-site-selector .pn-button-dropdown-label {
      border-radius: 48px;
    }
  }

  .siteheader-row pn-button.pn-button-dropdown-label {
    .pn-button[data-variant="borderless"][data-appearance="light"] .pn-button-bg::after {
      background-color: $blue700 !important;
    }

    .pn-button[data-appearance="light"] pn-icon .pn-icon-svg path {
      fill: $white !important;
    }

    button {
      .pn-button-text {
        color: $white !important;
      }
    }


  }
}

.header-wrapper[data-header-theme="tpl"] {
  & > pn-marketweb-siteheader {
    pn-button a {
      text-decoration: none;

      &:hover {
        text-decoration: none;
      }
    }

    [slot="header-bottom-button"] {
      @media screen and (max-width: $siteheader-media-tablet) {
        display: none;
      }

      display: flex;
      gap: 1rem;
      align-items: center;

      a {
        color: $blue900;
        font-weight: 500;
        font-size: 1.6rem;
        padding: 0.8rem 2.4rem;

        .pn-button-bg {
          background-color: $coral200;
        }

        .pn-button-content pn-icon svg > path {
          fill: $blue900;

          @media screen and (min-width: $siteheader-media-tablet) {
            fill: $white;
          }
        }

        &:hover {
          color: $white;

          .pn-button-bg {
            background-color: $blue900;
            transition: backgrond-color linear 1s;
          }

          .pn-button-content pn-icon svg > path {
            fill: $white;
          }
        }
      }
    }
    @media screen and (min-width: $siteheader-media-tablet) {
      .siteheader-row pn-button button:hover {
        .pn-button-bg,
        .pn-button-bg::after {
          background-color: $blue900;
          transition: initial;
        }
      }
    }

    & > header {
      .siteheader-row:not(:last-child) {
        background-color: $blue900;
        border-bottom: 0.1rem solid $blue900;
      }

      @media screen and (max-width: $siteheader-media-tablet) {
        .siteheader-row:last-child {
          background-color: $blue900;
        }
      }

      @media screen and (min-width: $siteheader-media-smalldesktop) {
        [data-level="1"] pn-mainnav-link > button::before,
        [data-level="1"] pn-mainnav-link > a::before {
          background-color: $coral200;
        }
      }

      [slot="siteheader-menu-top-button"] {
        @media screen and (min-width: $siteheader-media-tablet) {
          display: none;
        }

        @media screen and (max-width: 415px) {
          display: none;
        }

        background: $blue900;
        display: flex;
        align-items: center;

        a {
          color: $blue900;
          font-weight: 500;

          .pn-button-bg {
            background-color: $coral200;
          }

          .pn-button-content pn-icon svg > path {
            fill: $blue900;

            @media screen and (min-width: $siteheader-media-tablet) {
              fill: $white;
            }
          }

          &:hover {
            color: $white;

            .pn-button-bg {
              background-color: $blue900;
              transition: backgrond-color linear 1s;
            }

            .pn-button-content pn-icon svg > path {
              fill: $white;
            }
          }
        }
      }

      a {
        color: $blue900;
      }

      pn-mainnav-link button {
        color: $blue900;

        pn-icon svg path {
          fill: $blue900;
        }
      }

      .siteheader-topleft {
        pn-site-selector .pn-button-dropdown-label {
          color: $white;

          pn-icon {
            svg > path {
              fill: $white;
            }
          }

          &:hover {
            background: $blue400;
          }
        }
      }

      button.pn-button-dropdown-label {
        &:hover {
          background-color: $blue900;
        }

        &:active {
          background-color: $blue900;
        }

        &:focus {
          background-color: $blue900;
        }
      }

      .siteheader-logocontainer {
        background-color: $blue900;

        svg.siteheader-logo > path {
          fill: $blue400;
        }
      }

      .siteheader-topright {
        .siteheader-logindialog {
          svg > path {
            fill: $white;
          }
        }

        pn-language-selector {
          pn-icon {
            svg > path {
              fill: $white !important;
            }
          }
        }

        button {
          color: $white;

          &:hover {
            background-color: $blue400;
          }

          &:active,
          &:focus {
            background-color: $blue900;
          }
        }

        margin-right: 0;
        align-self: center;
        margin-left: 1rem;
      }

      div.siteheader-menu-top-search {
        display: inline-block;
        margin-top: auto;
        margin-bottom: auto;
        width: fit-content;

        @media screen and (max-width: $siteheader-media-tablet) {
          display: none;
        }

        pn-search-field {
          justify-content: flex-end;
          min-width: inherit;
        }

        form {
          margin-right: 0;
        }

        form:not(:focus-within) .input-container {
          position: absolute;
          width: 100%;

          input {
            cursor: pointer;
            background-color: transparent;
            color: transparent;
            border: none;
            position: relative;
            z-index: 3;
            border-radius: 0;

            &::placeholder {
              color: transparent;
            }
          }
        }

        .input-container:focus-within {
          margin-left: 2rem;

          input {
            background-color: $white;
            color: $blue900;
          }
        }

        .siteheader-search pn-button button {
          width: fit-content;
          padding: 1rem 1.9rem;

          .pn-button-bg {
            background: $blue900;
          }
        }
      }

      @media screen and (min-width: $siteheader-media-tablet) {
        .siteheader-row:last-child pn-marketweb-siteheader-search {
          display: none;
        }
      }

      .siteheader-search form pn-search-field {
        input {
          background-color: $white;
          color: $blue900;

          &:hover {
            border-color: $white;
          }

          &::placeholder {
            color: $blue900;
          }
        }
      }

      .siteheader-menu-footer {
        [slot="menu-footer-cta"] {
          display: none;
        }



        @media screen and (max-width: $min-width-md) {
          [slot="menu-footer-cta"] {
            display: flex;
            color: $blue900;
            flex-direction: column;
            gap: 0.5rem;

            .pn-button-bg {
              background-color: $coral200;
            }

            .pn-button-content {
              font-weight: 500;
              color: $blue900;

              pn-icon svg > path {
                fill: $blue900;

                @media screen and (min-width: $siteheader-media-tablet) {
                  fill: $white;
                }
              }
            }

            a:hover {
              color: $white;

              .pn-button-bg {
                background-color: $blue900;
                transition: backgrond-color linear 1s;
              }

              .pn-button-content pn-icon svg > path {
                fill: $white;
              }

              .pn-button-text {
                color: $white;
              }
            }
          }
        }

        @media screen and (max-width: 1024px) {
          pn-button-dropdown button:focus,
          pn-button-dropdown button:hover {
            color: $white;
            background-color: $blue400;
            box-shadow:
              0 0 0 0.2rem $white,
              0 0 0 0.4rem $blue400;

            svg > path {
              fill: $white;
            }
          }
        }

        button {
          color: $white;

          &:hover {
            background-color: $blue700;
          }

          &:active {
            background-color: $blue400;
          }

          &:focus {
            background-color: $blue400;
          }

          svg > path {
            fill: $white;
          }

          @media screen and (max-width: 1024px) {
            color: $blue900;

            pn-icon svg > path {
              fill: $blue900;
            }
          }
        }

        [slot="menu-footer-cta"] {
          @media screen and (min-width: $siteheader-media-tablet) {
            display: none;
          }
        }
      }
    }
  }
}
